export const CONFIG = {
    backendUrl: '/api',
}
